import { ObservablePropType } from "../ObservablePropType";
class BOOLEAN extends ObservablePropType {
  element = () => `<vs-switch></vs-switch>`;
  parse(value) {
    return value != null ? !!value : null;
  }
  constructorName = "BOOLEAN";
  elementValue(element) {
    element.checked = this.get();
  }
  format() {
    return this.get() ? "true" : "false";
  }
  render({ on, off } = {}) {
    const ip = $("<span></span>");
    const setContent = () => {
      ip.html(this.get() ? on || this.format() : off || this.format());
    };
    setContent();
    this.watch((val) => {
      setContent();
    });
    return ip.get(0);
  }
  toggle() {
    this.set(!this.get());
  }
}

export default BOOLEAN;
